import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Text from '../../Text';
import Arrow from './SecondaryNavMobileSubMenuArrow';
import Links from './SecondaryNavMobileSubMenuLinks';

import * as styles from './SecondaryNavMobile.module.less';

const SecondaryNavMobileSubMenu = ({ links, isOpen, onClick }) => {
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const onSubTabClick = () => {
    if (links.link) setSubmenuOpen(!submenuOpen);
    onClick(links.anchorId);
  };

  return (
    <li className={styles.subMenu__list}>
      <a
        href={
          !links.link && links.path ? links.path : `#side_${links.anchorId}`
        }
        onClick={onSubTabClick}
      >
        <Text
          className={classNames(styles.subMenu__menuItem, styles.subMenu__text)}
        >
          {links.name}
        </Text>
        {links.link && (
          <Text
            className={classNames(styles.subMenu__arrow, {
              [styles.subMenu__arrowOpen]: submenuOpen || isOpen,
            })}
          >
            {!isOpen && <Arrow />}
          </Text>
        )}
      </a>
      <div
        className={classNames(styles.subMenu__submenuWrapper)}
        id={links.anchorId}
      >
        <Links links={links.link} />
      </div>
      <hr />
    </li>
  );
};

SecondaryNavMobileSubMenu.propTypes = {
  links: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string,
    anchorId: PropTypes.string,
    link: PropTypes.arrayOf(PropTypes.object),
  }),
  isOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SecondaryNavMobileSubMenu.defaultProps = {
  links: [],
  isOpen: false,
};
export default SecondaryNavMobileSubMenu;
